(function () {

    'use strict';

    angular
        .module('app.layout')
        .controller('HeaderController', [
            'APP_CONFIG',
            '$scope',
            '$route',
            '$routeParams',
            '$q',
            'ApiService',
            'DataService',
            'CommonUtil',
            HeaderController
        ]);

    function HeaderController(APP_CONFIG, $scope, $route, $routeParams, $q, apiService, dataService, commonUtil) {

        var vm = this;

        vm.updateLanguageSelection = updateLanguageSelection;
        vm.getRootUrlInCaseCus = getRootUrlInCaseCus;

        init();

        function init() {
            $scope.$on('layoutInitSuccess', function () {
                if (angular.isDefined($routeParams.locCode) && angular.isDefined($routeParams.langCode)) {
                    vm.fullWidth = !!$route.current.headerFullWidth;

                    $q.all([apiService.getLocations($routeParams.langCode),
                        apiService.getStaticLocations($routeParams.langCode)]).then(function (response) {
                        var locations = response[0].data;
                        var staticLocations = response[1].data;
					    $scope.showOnlyForRichmond =$routeParams.locCode =='richmond' ? true:false;
                        var locationUrls = [];
                        var temp = [];
                        for (var i = 0; i < locations.length; i++) {
                            if (APP_CONFIG.DEFAULT_HOME === locations[i].locationCode) {
                                locationUrls.push({
                                    locationName: locations[i].locationName,
                                    locationUrl: getLocationUrl(locations[i]),
                                    locationCus: getLocationUrl(locations[i]) + '#cus',
                                    newWindow: false
                                });
                            } else {
                                temp.push({
                                    locationName: locations[i].locationName,
                                    locationUrl: (locations[i].externalUrl && locations[i].externalUrl.trim() != '') ? locations[i].externalUrl : getLocationUrl(locations[i]),
                                    locationCus: getLocationUrl(locations[i]) + '#cus',
                                    newWindow: (locations[i].externalUrl && locations[i].externalUrl.trim() != '') ? true : false
                                });
                            }
                        }
                        for (var i = 0; i < staticLocations.length; i++) {
                            temp.push({
                                locationName: staticLocations[i].locationName,
                                locationUrl: staticLocations[i].url,
                                locationCus: staticLocations[i].cus,
                                newWindow: true
                            });
                        }
                        vm.locations = locationUrls.concat(temp.sort(locationUrlCompare));
                    });
                    apiService.getLanguages().then(function (response) {
                        angular.forEach(response.data, function(value) {
                            value.nativeLanguageName = value.nativeLanguageName.toUpperCase();
                        });
                        vm.languages = response.data;
                        vm.selectedLanguage = apiService.getLanguageByCode(response.data, $routeParams.langCode);
                    });
                    apiService.getTranslationByCode($routeParams.langCode).then(function (response) {
                        angular.forEach(angular.element('.top-bar-section .title.back.js-generated a'), function (value) {
                            value.innerHTML = response.data['header.menu.back'];
                        });
                    });
                }
            });
        }

        function getLocationUrl(location) {
            return commonUtil.getLocationUrl(location, undefined, false, false);
        }

        function updateLanguageSelection(language) {
            dataService.setLanguageCodeIntoCookie(language.languageCode);
            $route.updateParams({
                langCode: language.languageCode
            });
        }

        function getRootUrlInCaseCus(id) {
            if ($route.current.isHome)
                return "";
            else
                return $scope.getRootUrl() + '#' + id;
        }

        function locationUrlCompare(a, b) {
            return a.locationName.localeCompare(b.locationName);
        }
    }

})();


// WEBPACK FOOTER //
// ./app/layout/header/HeaderController.js